export const APP_VERSION = '1.10.29'
